import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './VehicleGalleryLightbox.css'

function VehicleGalleryLightbox({ images, index = 0, open, onIndexChange, onClose, title = '' }) {
  const { t } = useTranslation()
  const count = images?.length ?? 0
  const idx = count > 0 ? ((index % count) + count) % count : 0

  const goPrev = () => {
    if (count <= 1) return
    onIndexChange((idx - 1 + count) % count)
  }

  const goNext = () => {
    if (count <= 1) return
    onIndexChange((idx + 1) % count)
  }

  useEffect(() => {
    if (!open) return undefined
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
      if (count <= 1) return
      if (e.key === 'ArrowLeft') onIndexChange((idx - 1 + count) % count)
      if (e.key === 'ArrowRight') onIndexChange((idx + 1) % count)
    }
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = prevOverflow
      window.removeEventListener('keydown', onKey)
    }
  }, [open, idx, count, onClose, onIndexChange])

  if (!open || count === 0) return null

  return (
    <div className="vd-lightbox" role="dialog" aria-modal="true" aria-label={t('detail.galleryTitle')}>
      <button type="button" className="vd-lightbox__backdrop" onClick={onClose} aria-label={t('detail.closeGallery')} />
      <div className="vd-lightbox__panel">
        <button type="button" className="vd-lightbox__close" onClick={onClose} aria-label={t('detail.closeGallery')}>
          ×
        </button>
        {count > 1 && (
          <>
            <button type="button" className="vd-lightbox__nav vd-lightbox__nav--prev" onClick={goPrev} aria-label={t('detail.prevImage')}>
              ‹
            </button>
            <button type="button" className="vd-lightbox__nav vd-lightbox__nav--next" onClick={goNext} aria-label={t('detail.nextImage')}>
              ›
            </button>
          </>
        )}
        <div className="vd-lightbox__stage">
          <img src={images[idx]} alt={title} className="vd-lightbox__img" />
        </div>
        {count > 1 && (
          <p className="vd-lightbox__counter">
            {t('detail.photoCounter', { current: idx + 1, total: count })}
          </p>
        )}
        {count > 1 && (
          <div className="vd-lightbox__thumbs">
            {images.map((src, i) => (
              <button
                key={`${src}-${i}`}
                type="button"
                className={`vd-lightbox__thumb ${i === idx ? 'vd-lightbox__thumb--active' : ''}`}
                onClick={() => onIndexChange(i)}
              >
                <img src={src} alt="" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default VehicleGalleryLightbox
